import React, {useState} from 'react';
import cn from 'classnames';

interface ISimpleCounter {
  name: string;
  onChange: (e: number) => void;
}

function SimpleCounter({name, onChange}: ISimpleCounter) {
  const [counter, setCounter] = useState(1);

  return (
    <div className="flex flex-col">
      <span className="font-medium">زمان ارائه نتیجه </span>
      <p className="text-md text-gray-900 mt-3">
        زمان تقریبی ارائه نتیجه آزمایش را مشخص کنید.
      </p>
      <div className="flex w-full items-center justify-between">
        <span>زمان تقریبی (روز کاری)</span>
        <div className="flex justify-center items-center">
          <i
            className={cn('icon-namePlus-2 text-xl', {
              'text-farm-shop-500': counter > 0,
              'text-gray-900': counter === 0,
            })}
            onClick={() => {
              setCounter(counter + 1);
              onChange(counter);
            }}
          />
          <span className="px-2">
            {counter} روز {'  '}
          </span>
          <i
            className={cn('icon-nameMinus-2 text-xl', {
              'text-farm-shop-500': counter > 0,
              'text-gray-900': counter === 0,
            })}
            onClick={() => counter >= 0 && setCounter(counter - 1)}
          />
        </div>
      </div>
    </div>
  );
}

export default SimpleCounter;
